import { Collection, Database } from '@nozbe/watermelondb';

import { DBServiceOptions } from '../../types/dbService';
import { UserSettingsModel } from '../../types/UserSettings';
import { DatabaseValidation } from '../../types/validation';
import {
    addPreparedDataBatch,
    mapRecord,
    PreparedUserSettingsData,
} from './helpers/userSettings/common';
import { validateEntityRecords } from './helpers/common/validateEntityRecords';
import {
    logSetUserSettingsEnabledAction,
    prepareSetUserSettingsEnabled,
} from './helpers/userSettings/userSettingsUpdate';

type UserSettingsServiceOptions = DBServiceOptions & {
    validation: DatabaseValidation;
};

class UserSettings {
    private database: Database;
    private collection: Collection<UserSettingsModel>;
    private table = 'user_settings';
    private options: UserSettingsServiceOptions;

    constructor(options: UserSettingsServiceOptions) {
        this.database = options.database;
        this.collection = options.database.collections.get(this.table);
        this.options = options;
    }

    getAll() {
        return this.collection.query().fetch();
    }

    getByID(id: string) {
        return this.collection.find(id);
    }

    async setIsEnabled(id: string, isEnabled: boolean) {
        const userSettingsElement = await this.getByID(id);

        await this.database.write(async () => {
            const preparedData: PreparedUserSettingsData[] = [];
            const updatedUserSettings = prepareSetUserSettingsEnabled({
                setting: userSettingsElement,
                isEnabled,
            });
            preparedData.push(
                mapRecord(updatedUserSettings, 'user_settings', 'update'),
            );

            validateEntityRecords(preparedData, this.options.validation);
            await addPreparedDataBatch(preparedData, this.database);

            logSetUserSettingsEnabledAction({
                setting: updatedUserSettings,
                logDBAction: this.options.logDBAction,
                tableName: this.table,
            });
        });
    }
}

export default UserSettings;
